
<div *ngIf="checklistRow" id="checklistModifyBody" class="border-outline">

  <div class="relative-container">
    <ng-container *ngIf="!editMode">
      <h3 class="outline-border-header">{{ sectionTitle }}</h3>
    </ng-container>
    <ng-container *ngIf="editMode">
      <div class="outline-border-header">
        <h3 style="min-width: 10em;" contenteditable="true" [textContent]="checklistRow.data[this.rowColumns[0]['name']]" (input)="checklistRow.data[this.rowColumns[0]['name']]=$event.target.textContent; markFormAsDirty()"></h3>
      </div>
    </ng-container>
  </div>

  <div class="relative-container" *ngIf="!isInitialUser && !readOnlyInitialChecklists && !editOnlyInitialChecklists">
    <div class="section-control-buttons">
      <div (click)="copySection()">
        <mat-icon>content_copy</mat-icon>
      </div>
      <div>
        <mat-icon *ngIf="!editMode && !editInProgress else editModeIcon" (click)="toggleEdit()">edit</mat-icon>
        <ng-template #editModeIcon><mat-icon class="disabled-icon">edit</mat-icon></ng-template>
      </div>
    </div>
  </div>

  <div *ngIf="showTable" #tableBody class="table-container"
        [ngClass]="{'display-mode': !editMode}"
        [ngStyle]="{'max-height': isTabStyle ? 'none': ''}">

    <table mat-table [dataSource]="dataSource">

      <!-- Empty cell -->
      <ng-container matColumnDef="intEmptyAdd" >
        <th mat-header-cell class="empty-a" *matHeaderCellDef style="border: none;"></th>
      </ng-container>

      <!-- Level Column control -->
      <!-- <ng-container matColumnDef="intEmptyLevel" >
        <th mat-header-cell class="empty-a" *matHeaderCellDef>
          <button
            *ngIf="editMode"
            mat-icon-button
            disableRipple
            class="clickable"
            color="accent"
            (click)="onAddColumn(-1)">
            <mat-icon class="icon-horizontal-offset">add</mat-icon>
          </button>
        </th>
      </ng-container> -->

      <!-- Empty cell -->
      <ng-container matColumnDef="intEmptyId" >
        <th mat-header-cell class="empty-a" *matHeaderCellDef></th>
      </ng-container>

      <!-- Column Controls -->
      <ng-container *ngFor="let column of controlNames; let i = index;" >
        <ng-container matColumnDef="{{ column }}">
          <th mat-header-cell *matHeaderCellDef class="empty-a">
            <div class="flex-container">
              <button mat-icon-button class="flex-1" style="visibility: hidden;">
                <mat-icon>masks</mat-icon>
              </button>
              <button
                *ngIf="editMode"
                mat-icon-button
                disableRipple
                class="flex-1 clickable"
                color="warn"
                (click)="onRemoveColumn(i)">
                <mat-icon>clear</mat-icon>
              </button>
              <button
                *ngIf="editMode"
                mat-icon-button
                disableRipple
                class="flex-1 clickable"
                color="accent"
                (click)="onAddColumn(i)">
                <mat-icon>add</mat-icon>
              </button>
            </div>
          </th>
        </ng-container>
      </ng-container>

      <!-- Empty cell -->
      <ng-container matColumnDef="intEmptyRemove">
        <th mat-header-cell class="empty-a" *matHeaderCellDef style="border: none;"></th>
      </ng-container>

      <!-- Add Control Column -->
      <ng-container matColumnDef="addControl">
        <th mat-header-cell *matHeaderCellDef>
          <div class="flex-td">
            <mat-checkbox
              [(ngModel)]="checklistRow.includeHeader"
              *ngIf="editMode"
              name="headerCheckbox"
              disableRipple
              matTooltip="include header"
              class="header-checkbox"
              (ngModelChange)="markFormAsDirty()">
            </mat-checkbox>
            <button
              *ngIf="editMode"
              mat-icon-button
              disableRipple
              class="clickable"
              color="accent"
              (click)="onAddRow(-1)">
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let element; let i = index;">
          <div class="flex-td-row">
            <mat-icon class="header-checkbox" *ngIf="element.locked" (click)="element.locked = !element.locked; markFormAsDirty()">lock</mat-icon>
            <mat-icon class="header-checkbox" *ngIf="!element.locked" (click)="element.locked = !element.locked; markFormAsDirty()">lock_open</mat-icon>
            <button *ngIf="editMode"
              mat-icon-button
              disableRipple
              class="clickable"
              color="accent"
              (click)="onAddRow(i)"
            >
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <!-- Level Control Column -->
      <!-- <ng-container matColumnDef="levelControl" *ngIf="editMode">
        <th mat-header-cell *matHeaderCellDef class="level-select">
          <mat-form-field floatLabel="never">
            <mat-select
              [(ngModel)]="maxLevelShown"
              [disabled]="readOnlyInitialChecklists"
              (ngModelChange)="onMaxLevelChange();"
              [placeholder]="('PROJECT.COMMON.PLEASE_SELECT' | anessaTranslation: trigger)">
              <mat-option
                *ngFor="let level of getLevels(getMaxLevel())"
                [value]="level">
                {{ level }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </th>
        <td mat-cell *matCellDef="let element; let i = index;" class="level-select">
          <mat-form-field
            floatLabel="never">
            <mat-select
              [value]="element.level"
              (selectionChange)="onLevelChange(i, $event.value);"
              [disabled]="readOnlyInitialChecklists"
              [placeholder]="('PROJECT.COMMON.PLEASE_SELECT' | anessaTranslation: trigger)">
              <mat-option
                *ngFor="let level of getLevels(element.level, element, false)"
                [value]="level">
                {{ level }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container> -->

      <!-- Item Columns -->
      <ng-container *ngFor="let column of columnNames; let colIndex = index;">
        <ng-container matColumnDef="{{ column }}">
          <!-- dont do anything if it's an initial user -->
          <th mat-header-cell *matHeaderCellDef>
            <div style="display: flex; align-items: center; justify-content: center;" (click)="isInitialUser || !editMode ? {} : onEditColumn(colIndex)">
              <span class="clickable">{{ columnNames[colIndex] }}</span>

              <div *ngIf="editMode" class="clickable relative-container" (click)="$event.stopPropagation(); toggleLock(column)">
                <mat-icon *ngIf="isLocked(column)">lock</mat-icon>
                <mat-icon *ngIf="!isLocked(column)">lock_open</mat-icon>
              </div>
            </div>
          </th>
          <td
            mat-cell
            class="align-cell-contents"
            *matCellDef="let element; let cellIndex = index;"
            (click)="edit(cellIndex, column)"
            [ngStyle]="getRowStyle(element, colIndex)">
            <span *ngIf="readOnlyInitialChecklists || !isEdit(cellIndex, column) || element.locked else editItemCell">
              <!-- Display coloured circle if hex code value -->
              <span
                *ngIf="isColourHexCode(element.data[column]) else standardDisplay"
                class="coloured-circle"
                [ngStyle]="{'background-color': element.data[column]}">
              </span>
              <ng-template #standardDisplay>
                <div *ngIf="!rowColumns[colIndex].isIcon else iconDisplay" class="input-locked" style="padding: 0 24px;" [ngStyle]="{'text-align': rowColumns[colIndex].align}">
                  {{ (element.data[column] != null) ? element.data[column] : '-' }}
                </div>
              </ng-template>
            </span>
            <ng-template #iconDisplay>
              <div class="icon-grey" *ngIf="element.data[column]?.icon">
                <mat-icon
                    matSuffix
                    matTooltip="{{ element.data[column]?.message }}">
                    {{element.data[column]?.icon}}
                  </mat-icon>
              </div>
            </ng-template>
            <ng-template #editItemCell>
              <div class="edit-table-cell-content-container">
                <mat-form-field floatLabel="never"
                  *ngIf="!rowColumns[colIndex].isIcon else iconDisplay">
                  <!-- Generic text input -->
                  <div class="input-locked">
                    <textarea
                      *ngIf="!hasCellOptions(element['uuid'], colIndex)"
                      matInput
                      cdkTextareaAutosize
                      [id]="('textarea-' + colIndex + '-' + cellIndex + '-' + rowIndex + '-' + checklistIndex)"
                      [name]="('textarea-' + colIndex + '-' + cellIndex + '-' + rowIndex + '-' + checklistIndex)"
                      class="form-input-textarea"
                      [class.empty-text-area]="!element.data[column]"
                      [disabled]="!hasEditAccess()"
                      [ngStyle]="{'text-align': rowColumns[colIndex].align}"
                      [placeholder]="element.dataPlaceholder[column]"
                      [matTooltip]="!element.data[column] ? element.dataPlaceholder[column] : ''"
                      [(ngModel)]="element.data[column]"
                      (ngModelChange)="markFormAsDirty()"
                      (focusout)="edit(null, null);">
                    </textarea>
                  </div>
                  <!-- User provided options -->
                  <mat-select
                    *ngIf="hasCellOptions(element['uuid'], colIndex)"
                    disableOptionCentering
                    [name]="('optionSelect-' + colIndex + '-' + cellIndex + '-' + rowIndex + '-' + checklistIndex)"
                    [disabled]="!hasEditAccess()"
                    [placeholder]="('PROJECT.COMMON.PLEASE_SELECT' | anessaTranslation: trigger)"
                    [(ngModel)]="element.data[column]"
                    (ngModelChange)="markFormAsDirty(); edit(null, null);">
                    <mat-select-trigger>
                      <!-- Display coloured circle if hex code value -->
                      <span
                        *ngIf="isColourHexCode(element.data[column]) else standardDisplay"
                        class="coloured-circle"
                        [ngStyle]="{'background-color': element.data[column]}">
                    </span>
                      <ng-template #standardDisplay>{{ element.data[column] }}</ng-template>
                    </mat-select-trigger>
                    <mat-option
                      *ngFor="let option of getCellOptions(element['uuid'], colIndex)"
                      [value]="option">
                      <!-- Display coloured circle if hex code value -->
                      <span
                        *ngIf="isColourHexCode(option) else standardOption"
                        class="coloured-circle"
                        [ngStyle]="{'background-color': option}">
                    </span>
                      <ng-template #standardOption>{{ option }}</ng-template>
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <!-- edit cell button -->
                <div *ngIf="editMode" class="clickable cell-plus-margin">
                  <mat-icon 
                    class="cell-plus-icon"
                    (click)="onCellOptionsClick(element, colIndex)">
                    edit_note
                  </mat-icon>
                </div>
              </div>
            </ng-template>
          </td>
        </ng-container>
      </ng-container>

      <!-- Remove Control Column -->
      <ng-container matColumnDef="removeControl">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let i = index;">
          <button
            *ngIf="editMode"
            mat-icon-button
            disableRipple
            class="clickable"
            color="warn"
            (click)="onRemoveRow(i)">
            <mat-icon class="icon-right-padding">clear</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedControls; sticky: true" class="control-row"></tr>
      <tr mat-header-row class="row2" *matHeaderRowDef="displayedColumns; sticky: true" [ngStyle]="{'display': !checklistRow.includeHeader && !editMode ? 'none': ''}"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>

  <div class="border-outline flex-container flex-align-item-center half-width" *ngIf="editMode">
    <h3 style="margin: 0px; margin-right: 2em">
      {{'PROJECT.PROJECT_INFO.CHECKLIST.SECTION_TYPE' | anessaTranslation: trigger}}
    </h3>
    <div class="flex-box">
      <mat-form-field floatLabel="never">
        <mat-select
          name="sectionTypeSelect"
          [(ngModel)]="checklistRow.sectionType"
          (ngModelChange)="markFormAsDirty()"
          [placeholder]="('PROJECT.COMMON.PLEASE_SELECT' | anessaTranslation: trigger)"
        >
          <mat-option
            *ngFor="let type of sectionTypes"
            [value]="type.value"
          >{{type.translationId | anessaTranslation: trigger}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <ng-container *ngIf="hasEditAccess() && !editMode && checklistRow.sectionType === SectionType.FEEDSTOCK">
    <div style="display: flex; justify-content: flex-end; margin-right: 3%;">
      <button
        class="mat-mdc-button"
        mat-button
        (click)="addFeedstock()">
        {{'PROJECT.FEEDSTOCK_LIST.ADD_FEED' | anessaTranslation: trigger}}
      </button>
      <button
        *ngIf="showDeleteButton()"
        class="mat-mdc-button btn-red"
        mat-button
        (click)="removeSection()">
        {{'ACC_ADMIN.DELETE' | anessaTranslation: trigger}}
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="editMode">
    <app-save-cancel-buttons
      [bypassPermissions]="this.isProjectInput"
      [formValid]="!readOnlyInitialChecklists"
      [showSidebarButtons]="false"
      (saveClick)="onSave()"
      (cancelClick)="onCancel()">
    </app-save-cancel-buttons>
  </ng-container>
</div>
